import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { Modal } from 'react-bootstrap';
import { useConstitutionModal } from '../context/ConstitutionModalContext';

const ConstitutionModalFooter: FC = () => {
  const { t } = useTranslate();
  const { data, actions } = useConstitutionModal();

  const buttonEnabledScriptureView =
    data.scriptureView &&
    data.date &&
    data.totalSharesToAdd > 0 &&
    data.nominalValue > 0;

  const buttonEnabledSaveMovement =
    data.sharesToAdd > 0 &&
    data.remainingShares >= data.sharesToAdd &&
    data.selectedPartner &&
    data.selectedHoldingClass &&
    !data.isValidateRangeEnabled;

  const buttonEnabledMovementsView =
    !data.scriptureView && data.remainingShares === 0 && data.sharesToAdd === 0;

  const buttonText = data.scriptureView ? t('Next') : t('SaveConstitution');

  return (
    <Modal.Footer>
      <div className="d-flex justify-content-between w-100">
        {!data.scriptureView && (
          <button
            type="button"
            className="btn btn-lg btn-primary"
            onClick={actions.handleSaveMovement}
            disabled={!buttonEnabledSaveMovement}
          >
            {t('SaveMovement')}
          </button>
        )}
        <button
          type="button"
          className="btn btn-lg btn-primary"
          onClick={actions.handleSaveConstitution}
          disabled={!buttonEnabledScriptureView && !buttonEnabledMovementsView}
        >
          {buttonText}
        </button>
      </div>
    </Modal.Footer>
  );
};

export default ConstitutionModalFooter;
